import React, { useState } from "react";
import "./NotificationSettings.css";

const NotificationSettings = ({ setMessage }) => {
  // Notification preferences state
  const [notificationSettings, setNotificationSettings] = useState({
    emailNotifications: true,
    activityUpdates: true,
    newFeatures: true,
    commentReplies: true,
    listUpdates: false
  });

  // Handle notification preference changes
  const handleNotificationChange = (e) => {
    const { name, checked } = e.target;
    setNotificationSettings((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Handle save notification settings
  const handleSaveNotificationSettings = () => {
    // This would actually call the API to save the settings
    // For now, it's just a mock function
    setMessage({
      type: "success",
      text: "Notification preferences updated successfully!"
    });
    
    // Auto-clear message after 5 seconds
    setTimeout(() => {
      setMessage({ type: "", text: "" });
    }, 5000);
  };

  return (
    <div className="notification-settings">
      <div className="settings-section">
        <h3>Email Notifications</h3>
        <p className="section-description">
          Control what notifications you receive via email.
        </p>
        
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="emailNotifications"
              checked={notificationSettings.emailNotifications}
              onChange={handleNotificationChange}
            />
            <span>Email Notifications</span>
          </label>
          <small>
            Receive important updates and announcements via email
          </small>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="activityUpdates"
              checked={notificationSettings.activityUpdates}
              onChange={handleNotificationChange}
            />
            <span>Activity Updates</span>
          </label>
          <small>Get notified about new comments and interactions</small>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="newFeatures"
              checked={notificationSettings.newFeatures}
              onChange={handleNotificationChange}
            />
            <span>New Features</span>
          </label>
          <small>
            Stay updated on new site features and improvements
          </small>
        </div>
      </div>

      <div className="settings-section">
        <h3>Social Notifications</h3>
        <p className="section-description">
          Control notifications about social interactions.
        </p>
        
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="commentReplies"
              checked={notificationSettings.commentReplies}
              onChange={handleNotificationChange}
            />
            <span>Comment Replies</span>
          </label>
          <small>
            Get notified when someone replies to your comments
          </small>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="listUpdates"
              checked={notificationSettings.listUpdates}
              onChange={handleNotificationChange}
            />
            <span>List Updates</span>
          </label>
          <small>
            Get notified when friends update their anime/manga lists
          </small>
        </div>
      </div>

      <div className="settings-section notification-info">
        <h4>Coming Soon</h4>
        <p>
          Push notifications and additional notification options will be available in future updates.
        </p>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="save-settings-btn"
          onClick={handleSaveNotificationSettings}
        >
          Save Notification Settings
        </button>
      </div>
    </div>
  );
};

export default NotificationSettings;